import React, { useState } from 'react'
import { defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine'
import ReactPlayer from 'react-player'
import Modal from '@mui/material/Modal'
import style from './block.module.scss'
import { ReactComponent as Play } from './play-button.svg'

const Inspector = React.lazy(() => import('./Inspector'))

const VideoPlayer = ({ video, miniature }) => {
    const { isEditing } = useEditor()
    const [modalOpen, setModalOpen] = useState(false)
    useInspectorControl(Inspector)

    return (
        <>
            <div
                className={style.block}
                style={miniature && { backgroundImage: 'url(' + miniature.url + ')' }}
            >
                <div
                    className={style.button}
                    onClick={() => setModalOpen(isEditing ? false : true)}
                >
                    <Play alt="Démarrer la vidéo" />
                </div>
            </div>

            <Modal
                open={modalOpen}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                BackdropProps={{ style: { backgroundColor: style.darkBlue, opacity: '0.54' } }}
                onClose={() => setModalOpen(false)}
            >
                <div className={style.modal}>
                    {video && (
                        <ReactPlayer
                            url={video.url}
                            playing={modalOpen}
                            width="100%"
                            height="100%"
                            controls
                            config={{
                                youtube: {
                                    playerVars: { showinfo: 0, autoplay: 1 },
                                },
                            }}
                        />
                    )}
                </div>
            </Modal>
        </>
    )
}

export default defineBlock({
    Block: VideoPlayer,
    smartProps: {
        video: smartProps.object.withDefault(null),
        miniature: smartProps.image,
        isInternal: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Lecteur vidéo',
    },
})
